import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchUserDataAction } from "../slices/authSlice";

/**
 * Track successful workspace-list resolution and offer profile revalidation
 * in the background, without the boot spinner.
 */
export const useWorkspaceListStatus = () => {
  const dispatch = useDispatch();
  const [retrying, setRetrying] = useState(false);
  const error = useSelector(
    (state) => state.auth.workspaceListError === true || Boolean(state.auth.userDataFetchError)
  );
  const fetched = useSelector((state) => state.auth.userDataFetchedThisSession === true);
  const retry = useCallback(async () => {
    setRetrying(true);
    try {
      await dispatch(
        fetchUserDataAction({ withScope: true, background: true, workspaceListRetry: true })
      );
    } finally {
      setRetrying(false);
    }
  }, [dispatch]);
  return { error, loaded: fetched && !error && !retrying, retry };
};
